export class ProjectBugReleases {
  BugID: number;
  TextLOC: string;
  TextENG: string;
  TipLOC: string;
  TipENG: string;
  DescriptionLOC: string;
  DescriptionENG: string;
  FunctionalAreas: string;
  FunctionalAreasENG: string;
  Countries: string;
  Priority: number;
  Severity: number;
  BugsStatus: number;
  RecordingDate: Date;
  Releases: BugReleases[];
  Inquiries: BugInquiries[];
}

export class BugReleases {
  BugID: number;
  ProductCode: string;
  ReleaseNrExpected: string;
  Description: string;
}

export class BugInquiries {
  InquiryID: number;
  ProductCode: string;
  ReleaseNr: string;
  Description: string;
  RecordingDate: Date;
}

export class BugGravities {
  constructor(gravity1: string, gravity2: string, gravity3: string, gravity4: string, gravity5: string, gravityUndefined: string) {
    this.Gravity1 = gravity1
    this.Gravity2 = gravity2
    this.Gravity3 = gravity3
    this.Gravity4 = gravity4
    this.Gravity5 = gravity5
    this.GravityUndefined = gravityUndefined
  }
  Gravity1: string;
  Gravity2: string;
  Gravity3: string;
  Gravity4: string;
  Gravity5: string;
  GravityUndefined: string;
}
